import React, { useEffect, useState } from "react";
import NewTitle from "../../extra/Title";

import { connect, useDispatch, useSelector } from "react-redux";
import Button from "../../extra/Button";

import { CLOSE_DIALOGUE } from "../../store/dialogue/dialogue.type";
import { useLocation, useNavigate } from "react-router-dom";
import SelectAllTransferList from "../../extra/TransferList";
import { getUserProfile } from "../../store/user/user.action";
import {
  gettingTheBadgeUser,
  setTheGoldenBadgeUser,
} from "../../store/goldenBadge/badge.action";
import SelectAllTransferListForBage from "../../extra/TransferListForBadge";

function ManageBadgeUser(props) {
  const [multiButtonSelect, setMultiButtonSelect] = useState("Profile");
  const [subscriber, setSubscriber] = useState([]);
  const [Unsubscriber, setUnsubscriber] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { dialogue, dialogueType, dialogueData } = useSelector(
    (state) => state.dialogue
  );
  const { badgeUser, unBadgeUser } = useSelector((state) => state.badge);
  // const subscribers = badgeUser;
  // // .map((user) => ({
  // //   name: user.fullName,
  // // }));
  // const unSubscribers = unBadgeUser;
  // // .map((user) => ({
  // //   name: user.fullName,
  // // }));
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);

  useEffect(() => {
    if (unBadgeUser && badgeUser) {
      setLeft(
        unBadgeUser.map((value) => ({
          id: value._id,
          name: value.fullName,
        }))
      );
      setRight(
        badgeUser.map((value) => ({
          id: value._id,
          name: value.fullName,
        }))
      );
    }
  }, [unBadgeUser, badgeUser]);

  // const [left, setLeft] = React.useState(
  //   unSubscribers.map((value) => {
  //     return { id: value._id, name: value.fullName };
  //   })
  // );
  // const [right, setRight] = React.useState(
  //   subscribers.map((value) => {
  //     return { id: value._id, name: value.fullName };
  //   })
  // );

  useEffect(() => {
    dispatch(gettingTheBadgeUser());
  }, [dispatch]);
  const handleSubmit = () => {
    let resultOfSubscribers = [];
    let resultOfunSubscribers = [];

    // Moved from Unsubscribed ➝ Subscribed
    if (unBadgeUser.length !== 0) {
      resultOfSubscribers = unBadgeUser
        .filter((user) => right.some((obj) => obj.id === user._id))
        .map((u) => u._id);
    }

    // Moved from Subscribed ➝ Unsubscribed
    if (badgeUser.length !== 0) {
      resultOfunSubscribers = badgeUser
        .filter((user) => left.some((obj) => obj.id === user._id))
        .map((u) => u._id);
    }

    console.log("Moved to Subscribers:", resultOfSubscribers);
    console.log("Moved to Unsubscribers:", resultOfunSubscribers);
    if (resultOfSubscribers.length > 0) {
      dispatch(
        setTheGoldenBadgeUser({ badge: true, ids: resultOfSubscribers })
      );
    }
    if (resultOfunSubscribers.length > 0) {
      dispatch(
        setTheGoldenBadgeUser({ badge: false, ids: resultOfunSubscribers })
      );
    }
  };

  const handleClose = () => {
    if (dialogueData) {
      dispatch({
        type: CLOSE_DIALOGUE,
        payload: {
          dialogue: false,
        },
      });

      let dialogueData_ = {
        dialogue: false,
      };
      localStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
    } else {
      console.log("close");
      navigate(-1);
    }
  };

  return (
    <div className="userSetting">
      <div className="dashboardHeader primeHeader mb-3 p-0"></div>
      <div className="row">
        <div className="col-4">
          <div className="mb-0 pb-2">
            <NewTitle titleShow={true} name={"Golden Badge Users"} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="general-setting fake-user video-upload-page mt-3">
          <div className=" userSettingBox">
            <form>
              <div className="row d-flex  align-items-center">
                <div className="col-6">
                  <h5 className="mb-0 text-nowrap">Golden Badge Users</h5>
                </div>
                {/* <div className="col-6 d-flex justify-content-end">
                  <Button
                    btnName={"Back"}
                    newClass={"back-btn"}
                    onClick={handleClose}
                  />
                </div> */}
                <div
                  className="col-12 d-flex justify-content-end align-items-center"
                  style={{
                    paddingTop: "23px",
                    marginTop: "11px",
                    borderTop: "1px solid #c9c9c9",
                  }}
                ></div>
                <div className="row">
                  <div className="col-12 d-flex justify-content-end align-items-center">
                    <SelectAllTransferListForBage
                      leftLabelName={"UnBadge Users "}
                      rightLabelName={"Badge Users"}
                      left={left}
                      right={right}
                      setLeft={setLeft}
                      setRight={setRight}
                      subscriber={subscriber}
                      setSubscriber={setSubscriber}
                      Unsubscriber={Unsubscriber}
                      setUnsubscriber={setUnsubscriber}
                      subscribers={badgeUser}
                      unSubscribers={unBadgeUser}
                    />
                  </div>

                  <div
                    className="col-12 d-flex justify-content-end align-items-center"
                    style={{
                      paddingTop: "32px",
                      marginTop: "40px",
                      borderTop: "1px solid #c9c9c9",
                    }}
                  ></div>
                  <div className="col-12 d-flex justify-content-end align-items-center">
                    <Button
                      onClick={handleSubmit}
                      newClass={"submit-btn"}
                      btnName={"Submit"}
                      type={"button"}
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
export default connect(null, {})(ManageBadgeUser, gettingTheBadgeUser);
